var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/autosuggest-account.tsx";
import React, { useCallback } from 'react';
import Account from 'soapbox/components/account';
import { useAppSelector } from 'soapbox/hooks';
import { makeGetAccount } from 'soapbox/selectors';

const AutosuggestAccount = _ref => {
  let {
    id
  } = _ref;
  const getAccount = useCallback(makeGetAccount(), []);
  const account = useAppSelector(state => getAccount(state, id));
  if (!account) return null;
  return /*#__PURE__*/React.createElement(Account, {
    account: account,
    hideActions: true,
    showProfileHoverCard: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 10
    }
  });
};

export default AutosuggestAccount;